import { Renderer2, RendererFactory2, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ScrollSpyService {
  _renderer: Renderer2

  constructor(rendererFactory: RendererFactory2) {
    this._renderer = rendererFactory.createRenderer(null, null);
  }

  getListOfElements(arrayOfNavs, arrayOfElements) {
    const listOfNavs = [];
    for(let nav of arrayOfNavs) {
      listOfNavs.push({navigation: nav.nativeElement});
    }

    const listOfElementsCords = [];
    for(let element of arrayOfElements) {
      listOfElementsCords.push({
        top: element.nativeElement.offsetTop,
        bottom: element.nativeElement.offsetTop + element.nativeElement.offsetHeight
      })
    }

    const listOfElements = [];
    for(let i = 0; i < listOfElementsCords.length; i++) {
      listOfElements.push({
        navigation: listOfNavs[i].navigation,
        top: listOfElementsCords[i].top,
        bottom: listOfElementsCords[i].bottom
      })
    }
    return listOfElements;
  }

  scrollSpy(listOfElements) {
    this._renderer.listen(window, 'scroll', () => {
      listOfElements.forEach(element => {
        if(window.pageYOffset >= (element.top - 43) && window.pageYOffset < (element.bottom - 43)) {
          this._renderer.addClass(element.navigation, 'header_nav_block-active');
        } else {
          this._renderer.removeClass(element.navigation, 'header_nav_block-active');
        }
      });
    });
  }

  fixNav(header) {
    this._renderer.listen(window, 'scroll', () => {
      if(window.pageYOffset >= 42) {
        this._renderer.addClass(header.nativeElement, 'fixed');
      } else {
        this._renderer.removeClass(header.nativeElement, 'fixed');
      }
    });
  }

  onNavClick(listOfElements) {
    listOfElements.forEach(element => {
      this._renderer.listen(element.navigation, 'click', () => window.scrollTo(0, (element.top - 42)));
    });
  }

  onResize(listOfElements) {
    this.onNavClick(listOfElements);
    this.scrollSpy(listOfElements);
  }

  startScrollSpy(listOfElements, header) {
    this.onNavClick(listOfElements);
    this.fixNav(header);
    this.scrollSpy(listOfElements);
  }
}